import angular from "angular";
import invitesControlComponent from "./invites-control.component";

angular.module('invitesControl', [invitesControlComponent]);

export default 'invitesControl';



// WEBPACK FOOTER //
// ./resources/assets/modules/invites-control/invites-control.module.js